<div class="modal-header">
    <h4 class="modal-title">{{'thesisReport_summaryTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <app-table [rows]="data.Doctors" [columns]="columns" [style]="'plain'">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.FirstName}} {{row.LastName}}</td>
                <td>{{row.Upn}}</td>
                <td class="text-center">
                    <i class="fi fi-rs-check" *ngIf="row.HasReport"></i>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">{{'close' | translate}}</button>
</div>
